<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <Activity />

        <FooterBlock />
    </div>
</template>

<script>
import Activity from '@/components/view_blocks/Activity/Activity_wrap.vue';
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';

export default {
  components: {
    Activity,
    HeaderMenu,
    FooterBlock,
  },
};
</script>
